export default __webpack_public_path__ + "51417d715eefba2c71698985b313b601.svg";